import React from 'react'

import Link from '~components/Link'
import style from './Menu.module.scss'

const Menu = ({
  microcopy
}) => (
  <nav role='navigation' className={style.menu}>
    <ul>
      { process.env.GATSBY_FEATURE_GUIDES === 'true' && (
        <li>
          <Link 
            to='/get-started/' 
            microcopy={microcopy}
            className={style.link}
            activeClassName={ style.activeLink }
            partiallyActive
          >
            { microcopy.text('guides.titles.quick_start_guides') }
          </Link>
        </li>
      )}
      { process.env.GATSBY_FEATURE_GUIDES === 'true' && (
        <li>
          <Link 
            to='/guides/' 
            microcopy={microcopy}
            className={style.link}
            activeClassName={ style.activeLink }
            partiallyActive
          >
            { microcopy.text('headers.primary.links.guides.text') }
          </Link>
        </li>
      )}
      { process.env.GATSBY_FEATURE_REFERENCE === 'true' && (
        <li>
          <Link 
            to='/reference/' 
            microcopy={microcopy}
            className={style.link}
            activeClassName={ style.activeLink }
            partiallyActive
          >
            { microcopy.text('headers.primary.links.api_reference.text') }
          </Link>
        </li>
      )}
      { process.env.GATSBY_FEATURE_PAGES === 'true' && (
        <li>
          <Link 
            to='/sdks-and-tools/' 
            microcopy={microcopy}
            className={style.link}
            activeClassName={ style.activeLink }
            partiallyActive
          >
            { microcopy.text('headers.primary.links.sdks_and_tools.text') }
          </Link>
        </li>
      )}
      { process.env.GATSBY_FEATURE_PAGES === 'true' && (
        <li>
          <Link 
            to='/support/' 
            microcopy={microcopy}
            className={style.link}
            activeClassName={ style.activeLink }
            partiallyActive
          >
            { microcopy.text('headers.primary.links.support.text') }
          </Link>
        </li>
      )}
    </ul>
  </nav>
)

export default Menu
